// @flow
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import type { Location, StaticRouterContext } from 'react-router-dom';
import { connect } from 'react-redux';
import type { CurrentUser } from 'api/currentUser';
import { RouterLink } from 'components/Link';
import { isEnabled as idealistDaysEnabled } from 'utils/idealistdayevents';

const getPath = ({ orgs, groups }: CurrentUser) => {
  if (orgs && groups) {
    if (orgs.length === 1 && groups.length === 0) {
      const org = orgs[0];
      if (!org.canPostGradProgram && org.isApproved) {
        return `/admin/${org.id}/jobs/create`;
      }

      if (org.isAllowedToPost && !org.isFrozen) {
        return `/admin/${org.id}/post-a-listing`;
      }
      return `/admin/${org.id}`;
    }
    if (orgs.length === 0 && groups.length === 1) {
      const group = groups[0];
      if (group.isApproved && !group.isFrozen) {
        return idealistDaysEnabled()
          ? `/group-admin/${group.id}/post-a-listing`
          : `/group-admin/${group.id}/volops/create`;
      }
      return `/group-admin/${group.id}`;
    }
  }
  return '/post-a-listing';
};

const PostListingLink = ({
  children,
  location,
  component,
  currentUser,
  staticContext,
  dispatch,
  ...props
}: {
  children?: React.Node,
  location: Location,
  component?: React.ElementType,
  currentUser: CurrentUser,
  staticContext: StaticRouterContext,
  dispatch: Function,
  'data-qa-id': string
}) => {
  const Component = component || RouterLink;
  const pathname = getPath(currentUser);
  return (
    <Component
      to={{
        pathname,
        state: { from: location.pathname }
      }}
      from={location.pathname}
      data-qa-id={props['data-qa-id'] || 'post-a-listing'}
      {...props}
    >
      {children || getText('Post a Listing')}
    </Component>
  );
};

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default withRouter(connect(mapStateToProps)(PostListingLink));
